import axios from "axios";
import React from "react";
import MailSvg from "./MailSvg";
import closeButtonIcon  from "../sources/closeModal.svg";


export default function Contact(props) {
  let nameInp = document.querySelector("#name-input");
  let emailInp = document.querySelector("#email-input");
  let textarea = document.querySelector("#textarea");
  let sendBtn = document.querySelector("#send-btn");

  let valid = function (e) {
    let feedback = "Name: " + nameInp.value + " Email: " + emailInp.value + " Message: " +  textarea.value;
    fetch(
      "https://api.telegram.org/bot5243359912:AAEAO7IMaJZQw5XnRqc7wEsKx742ky5ewdI/sendMessage?chat_id=-1001598250417&parse_mode=html&text=" +
        feedback,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(),
      }
    ).then(()=>{
        // alert("Message sent / Wiadomośc została wysłana");
        handleModal()
    })
        // .catch(alert("Form error / Błąd formy"))

  };

  // const modalSuccess = () =>{
  //     if()
  //   };

  const [userName, setUserName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [emailDirty, setEmailDirty] = React.useState(false);
  const [emailError, setEmailError] = React.useState('fill your email / wpisz swój email');
  const [message, setMessage] = React.useState('');
  const [formValid, setFormValid] = React.useState(false);
  const [modalSuccess, setMoadlaSuccess] = React.useState('modal-success');

  React.useEffect(() => {
    if(emailError){
      setFormValid(false)
    } else {
      setFormValid(true)
    }
  }, [emailError, modalSuccess]);

  const emailHadler = (e) => {
    setEmail(e.target.value)
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    if(!re.test(String(e.target.value).toLowerCase())){
      setEmailError('uncorrect email / nieprawidłowy email')
    } else{
      setEmailError('')
    }
  }

  const blur = (e) => {
    
    if( e.target.name === "user_email" ) {
      setEmailDirty(true)
    }
  }

    const handleModal = () => {
        modalSuccess === 'modal-success' ? setMoadlaSuccess('modal-success_open') : setMoadlaSuccess('modal-success');
    };
  return (
    <div className="contact animate__animated animate__fadeInRight">
      <span className="background_text">{props.contact.title}</span>
      <h1 className="title">{props.contact.title}</h1>
      <div className="contact_form">
        <form action="" method="">
          <input onChange={(e) => {setUserName(e.target.value)}} value={userName} type="text" name="user_name" id="name-input"  placeholder="name / imie"/>
          {(emailDirty && emailError) && <div className='error-email'>{emailError}</div>}
          <input onBlur={e => blur(e)}
            onChange={ (e) => {emailHadler(e);setEmail(e.target.value)}}
            value={email}
            type="text"
            name="user_email"
            id="email-input"
            placeholder="email / poczta"
          />
          <textarea
          placeholder="...mesage / wiadomośc"
            onChange={(e) => {setMessage(e.target.value)}}
            name="user_message"
            id="textarea"
            cols=""
            rows=""
          ></textarea>
        <button disabled={!formValid} type="button" id="send-btn" onClick={valid}>
          Send
        </button>
      </form>
      </div>
        <div className={modalSuccess} onClick={handleModal}>

            <h3>
                message has been sent / Wiadomośc została wysłana
            </h3>
        </div>
      <MailSvg/>
    </div>
  );
}
